import React from 'react'
import classnames from 'classnames'
import { cdnImg } from 'meinian-package/src/utils/image'
import CollectGroupBtn from 'component/collectGroupBtn'
import Icon from 'meinian-package/src/component/icon'
import { conversionRate } from 'meinian-package/src/utils/number'
import base from 'meinian-package/src/utils/base'
import styles from './index.module.less'

// 直播相关
const liveMap = new Map([
  // ['销量', item => base.autoFormatNumber(item.douyinGoods?.videoSaleVolume || item?.totalSaleVolume || 0)],
  ['直播销量', item => base.autoFormatNumber(item.douyinGoods?.liveSaleVolume)],
  ['视频', item => base.autoFormatNumber(item.douyinGoods?.relateProductNum)],
  ['直播', item => base.autoFormatNumber(item.douyinGoods?.relateLiveNum)],
  ['达人', item => base.autoFormatNumber(item.douyinGoods?.relateProductStreamerNum)],
  ['本期点赞', item => base.autoFormatNumber(item.douyinGoods?.relateVideoLikeNum)],
  ['主播', item => base.autoFormatNumber(item.douyinGoods?.relateLiveStreamerNum)],

  ['近7天直播销量', item => base.autoFormatNumber(item.douyinGoods?.relateLiveSaleVolume7day)],
  ['近3天直播销量', item => base.autoFormatNumber(item.douyinGoods?.relateLiveSaleVolume3day)],
  ['月直播销量', item => base.autoFormatNumber(item.douyinGoods?.relateLiveSaleVolume30day)],

  ['关联视频点赞', item => base.autoFormatNumber(item.douyinGoods?.relateVideoLikeNum)],
  ['近7天点赞', item => base.autoFormatNumber(item.douyinGoods?.relateVideoLikeNum7day)],
  ['月关联点赞', item => base.autoFormatNumber(item.douyinGoods?.relateVideoLikeNum30day)],
  // 商品昨日信息
  ['昨日销量', item => base.autoFormatNumber(item?.douyinGoods?.windowSaleVolumeYesterday || item?.saleVolumeYesterday)],
  ['昨日浏览', item => base.autoFormatNumber(item?.douyinGoods?.windowViewNumYesterday || item?.viewNumYesterday)],
  // 商品月信息
  ['月转化率', (item) => {
    const { viewNum30day, saleVolume30day } = item
    const { windowViewNum30day, windowSaleVolume30day } = item.douyinGoods || {}
    return conversionRate((windowViewNum30day || viewNum30day), (windowSaleVolume30day || saleVolume30day))
  }],

  ['月浏览', item => base.autoFormatNumber(item.douyinGoods?.windowViewNum30day || item?.viewNum30day)],
  ['月销量', item => base.autoFormatNumber(item.douyinGoods?.windowSaleVolume30day || item?.saleVolume30day)],
  ['月点赞', item => base.autoFormatNumber(item.douyinGoods?.relateVideoLikeNum30day || item?.videoLikeNum30day)],
  ['月评价', item => base.autoFormatNumber(item.douyinGoods?.commentNum30day)],

  ['浏览', item => base.autoFormatNumber(item?.totalViewNum || 0)],
  ['销量', item => base.autoFormatNumber(item?.totalSaleVolume || 0)],
  ['评价', item => base.autoFormatNumber(item?.totalCommentNum || 0)],
  ['本期浏览', item => base.autoFormatNumber(item?.newViewNum)],
  ['本期销量', item => base.autoFormatNumber(item?.newSaleVolume)],
  ['总浏览', item => base.autoFormatNumber(item?.totalViewNum)],
  ['总销量', item => base.autoFormatNumber(item?.totalSaleVolume)],
  ['合作直播', item => base.autoFormatNumber(item.douyinGoods?.relateLiveNum)],
  ['合作视频', item => base.autoFormatNumber(item.douyinGoods?.relateProductNum)],
])

/**
 * 基础商品卡片
 * @param {object} data 商品信息
 * @param {function(data)} onJump 点击后调用方法
 * @param {string[]} [tagFields=['直播销量']] 显示tag的字段
 * @param {[{label, value}, ...]} costumedTags 自定的tag字段
 * @param {string[]} [footerFields=['视频', '直播', '主播'],] 显示footerTag的字段
 * @param {[{label, value}, ...]} costumedFooterFields 自定义的footerTag字段
 * @param {(data) => DOM} dateSlot 日期插槽，默认取douyinGoods?.liveSaleTime || latestSaleDate 字段值
 * @param {boolean} [showOnHover=false] 是否仅展示图片，悬浮后显示信息
 * @param {boolean} canExport 是否显示导出勾选框
 */
function LiveItem(props) {
  const {
    onJump, tagFields = ['直播销量'], costumedTags = [],
    costumedFooterFields = [], footerFields = ['视频', '直播', '主播'],
    dateSlot = _data => <>{(_data.douyinGoods?.liveSaleTime || _data.latestSaleDate)?.slice(0, 10)}&nbsp;上架</>,
    columnWidth
  } = props

  const data = props?.itemData || props // 兼容

  const onClick = () => {
    if (onJump) {
      return onJump(data)
    }
    window.open(`/douyin/itemDetail/info?itemId=${data.itemId}`)
  }
  const title = data.goodsTitle || data.title || ''
  const price = (data.goodsPrice / 100)
  const minPrice = (data.minPrice / 100)
  const infoHeight = 100
  return <div
    className={classnames(styles['meinian-waterfall-card-item'])}
    style={{ width: columnWidth, height: columnWidth + 180, display: 'flex', flexDirection: 'column' }}
  >
    <div
      className="meinian-waterfall-card-image"
      style={{ height: `calc(100% - ${infoHeight}px)` }}
      onClick={onClick}
    >
      <div className="image-card-top-mask">
        <div className="image-card-top-btn">
          <CollectGroupBtn currentBlog={data} />
        </div>
        {data.douyinGoods?.hasGoodsStreamerNum && <span
          className={`${classnames(
            'douyin-item-card-extra-info-right',
          )}`}
        >带货达人&nbsp;
          <span className="streamer-number">{data.douyinGoods?.hasGoodsStreamerNum}</span>
          </span>}
      </div>
      <img
        loading="lazy"
        src={cdnImg(data.picUrl, 500)}
        style={{ width: '100%', height: '100%', objectFit: 'cover', background: 'linear-gradient(rgba(0,0,0,0.03), rgba(0,0,0,0.03))' }}
      />
    </div>
    <div className="card-body">
      {/* 商品价格 */}
      <div className="card-price-wrap-wrap">
        <div className="card-price-wrap">
          <span className="card-price">¥{price}</span>
          <span className="card-min-price">最低&nbsp;¥{minPrice}</span>
        </div>
      </div>
      {/* 商品标题 */}
      <div className="card-title" title={title}>{title}</div>
      {/* 店铺名称和slot */}
      <div className="shop-wrapper">
        <span className="shop-name">
          {data.goodsType === 100 && <Icon type="m-doudian" className="icon-goods-type" />}
          {data.goodsType === 101 && <Icon type="m-taobaozhuye" className="icon-goods-type" />}
          <div className="shop-name-title">{data.shopName || '未知店铺'}</div>
        </span>
        <span>{dateSlot(data)}上架</span>
      </div>
      {/* 次要数据 */}
      <div className="card-tags">
        {costumedTags?.length !== 0 && costumedTags.map(el => <span>{el.label}&nbsp;{el.value}</span>)}
        {tagFields.map(label => <span>{label}&nbsp;{liveMap.get(label)?.(data)}</span>)}
      </div>
      {/* footer数据 */}
      {costumedFooterFields?.length > 0 && <div className="card-footer">
        {costumedFooterFields.map(el => <span className="card-block-item">
          {el.label}
          <span style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>
            {el.value}
          </span>
        </span>)}
      </div>}
      {footerFields?.length > 0 && <div className="card-footer">
        {footerFields.map(label => <span className="card-block-item">
          {label}
          <span style={{ color: 'var(--m-text-1)', marginLeft: '4px' }}>
            {liveMap.get(label)?.(data)}
          </span>
        </span>)}
      </div>}
    </div>
  </div>
}

/**
 * 抖衣商品
 */

const DouyinItem = props => <LiveItem
  footerFields={['月浏览', '月销量', '月评价']}
  tagFields={['销量']}
  dateSlot={data => (data.douyinGoods?.firstRecordTime || data.firstRecordTime)?.split(' ')[0]}
  {...props}
/>

export default DouyinItem
